import React, { FunctionComponent, useState, useEffect } from 'react';

export const StudioContext = React.createContext(undefined as any);

export interface StudioProviderProps {

}

export const StudioProvider: FunctionComponent<any> = (props: React.PropsWithChildren<StudioProviderProps>) => {
    const [searching, setSearching]= useState(false);
    const [filtering, setFiltering]= useState(false);
    const [filtersTemplates, setFiltersTemplates]= useState<any|undefined>();

    const [globalDesigns, setGlobalDesigns] = useState<any[]>([]);
    const [currentDesigns, setCurrentDesigns] = useState<any[]>([]);
    const [loadingMoreDesigns, setLoadingMoreDesigns] = useState(false);

    const [options, setOptions] = useState(["RECENT"]);
    const [value, setValue] = useState("RECENT");

    const [copyTemplate, setCopyTemplate] = useState<any | undefined>(undefined);

    const addDesignFromTemplate= (template: any) => {
        setSearching(false);
        setFiltering(false);
        setCopyTemplate(template);
    }

    return (
        <StudioContext.Provider value={{
            copyTemplate,
            addDesignFromTemplate: (template:any)=>addDesignFromTemplate(template),
            setCopyTemplate: (value:any)=>setCopyTemplate(value),
            searching,
            setSearching: (value:boolean)=>setSearching(value),
            filtering,
            setFiltering: (value:boolean)=>setFiltering(value),
            globalDesigns,
            setGlobalDesigns: (value:any[])=>setGlobalDesigns(value),
            currentDesigns,
            setCurrentDesigns: (value:any[])=>setCurrentDesigns(value),
            loadingMoreDesigns,
            setLoadingMoreDesigns: (value:boolean)=>setLoadingMoreDesigns(value),
            options,
            setOptions: (value:any[])=>setOptions(value),
            value,
            setValue: (value:string)=>setValue(value),
            filtersTemplates,
            setFiltersTemplates: (value:any)=>setFiltersTemplates(value),
        }}>
            {props.children}
        </StudioContext.Provider>
    )
}